import { CardDetails, Milestone, Product } from "../types/order";
import { Button } from "@/components/ui/button";
import useOrderStageStatus from "../hooks/useOrderStageStatus";

const CustomerCardsWithRejectedToggle = ({ product_list, orderType = 'buy', milestones, hasCardAssigned = false, setTab, cardDetails }: {
    product_list: Product[],
    hasCardAssigned?: boolean,
    setTab?: (tab: string) => void;
    cardDetails?: CardDetails;
    milestones?: Milestone[];
    orderType?: string;
}) => {

    const groupedProducts = product_list?.reduce((acc, product) => {
        const cardProducts = [16, 35, 36]
        const key = cardProducts.includes(product.product_id) ? 'card' : 'currency';
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(product);
        return acc;
    }, {} as Record<string, Product[]>);

    const cardDetailsWithProducts = Object.entries(groupedProducts || {}).map(
        ([type, products]) => {
            if (type === 'card') {
                return {
                    type: 'card',
                    products: products || [],
                }
            }
            return {
                products: products || [],
            }
        }
    )

    const {
        getAllButtonStates,
    } = useOrderStageStatus(milestones || []);


    return (
        <div className="flex flex-row gap-4 overflow-auto w-full">
            {cardDetailsWithProducts?.map((product, key) => {
                if (product.type === 'card') return (
                    <div
                        role="button"
                        onClick={() => setTab && setTab('product-charges')}
                        className="h-full w-full">
                        <div className="col-span-1 gap-2 w-full ">
                            <div className="p-4 w-full rounded-xl shadow border space-y-2 cursor-pointer">
                                <div className="flex justify-between w-full items-center font-medium">
                                    <div className="flex flex-row gap-2 items-center w-full">
                                        {
                                            !hasCardAssigned && (
                                                <>
                                                    <Button
                                                        variant="ghost"
                                                        disabled={
                                                            getAllButtonStates?.disableAll?.disabled ||
                                                            product.products?.some((item) => item.status === "Reject") ||
                                                            milestones?.some(
                                                                (m) =>
                                                                    m.stage?.toLowerCase() === "order cancelled" &&
                                                                    m.status?.toLowerCase() === "fulfilled"
                                                            )
                                                        }
                                                        className="bg-[#EFF4FF] p-2 rounded-[10px] text-blue-700 font-semibold leading-4 text-sm tracking-normal"
                                                    >
                                                        Assign Card +
                                                    </Button>
                                                    <div className="border-l text-center h-5" />
                                                </>
                                            )
                                        }

                                        <div className="text-[#333333] text-[13px]">
                                            {[36, 16].includes(product?.products?.[0].product_id)
                                                ? "Forex Card"
                                                : product?.products?.[0].name}
                                        </div>

                                        {
                                            hasCardAssigned &&
                                            <div className="flex items-center gap-3">
                                                <p className="text-xs text-[#666666]">{cardDetails?.card_number?.replace(/(\d{4})(?=\d)/g, '$1-')}</p>
                                                <div className="border-l text-center h-5" />
                                                <p className="text-xs text-[#666666]">{cardDetails?.action_type}</p>
                                            </div>
                                        }
                                        <div className="border-l text-center h-5" />
                                    </div>
                                    <a href="#" className="text-blue-500 text-xs">↗</a>
                                </div>
                                <hr />
                                <div className="flex items-start gap-3 w-full">
                                    {product.products?.map((item) => (
                                        <small className={` ${item.status === 'Reject' ? 'text-red-500 bg-red-200' : ' '} py-[1px] px-2.5 border rounded-[7px] text-xs font-normal leading-[160%] tracking-[-2%] text-black-label`}>
                                            {`${orderType === 'buy' ? item.country_currency_want : item.country_currency_have} ${item.quantity}`}{" "}
                                        </small>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                );
                return (
                    <div
                        key={key}
                        className='w-full'
                        role="button"
                        onClick={() => setTab && setTab('product-charges')}
                    >
                        <div className="col-span-1 gap-2 w-full ">
                            <div className="p-4 min-w-[260px] w-full rounded-xl shadow border space-y-2 cursor-pointer">
                                <div className="flex justify-between items-center font-medium">
                                    <div className="flex flex-row gap-2 items-center">
                                        <div className="text-[#333333] text-[13px]">{product?.products?.[0].name === 'Forex Currency Notes' ? 'Currency Notes' : product?.products?.[0].name}</div>
                                        <div className="border-l text-center h-5" />
                                    </div>
                                    <a href="#" className="text-blue-500 text-xs">↗</a>
                                </div>
                                <hr />
                                <div className="flex items-start gap-2 justify-between w-full overflow-auto">
                                    {product.products.map((item) => (
                                        <small className={` ${item.status === 'Reject' ? 'text-red-500 bg-red-200' : ' '} py-[1px] px-2.5 border rounded-[7px] text-xs font-normal leading-[160%] tracking-[-2%] text-black-label`}>
                                            {`${item.country_currency_want} ${item.quantity}`}{" "}
                                        </small>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}

        </div>
    );
};
export default CustomerCardsWithRejectedToggle;